var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-button",class:[_vm.color]},[_c('span',[_vm._t("default")],2),_c('div',{staticClass:"icon-wrapper"},[_c('icon-arrow-right')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }